import { render } from "./movimentos-list-nova.vue?vue&type=template&id=d495a968"
import script from "./movimentos-list-nova.vue?vue&type=script&lang=js"
export * from "./movimentos-list-nova.vue?vue&type=script&lang=js"

import "./movimentos-list-nova.vue?vue&type=style&index=0&id=d495a968&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__